import { reduceMarks } from './reduce'
import { ParseResult, ParserMapFunction, ParserSplitFunction } from './types'

export const parse = (
  input: string,
  splitInput: ParserSplitFunction,
  mapMarks: ParserMapFunction,
): ParseResult => {
  return reduceMarks(mapMarks(splitInput(input)))
}
